import { useMemo } from 'react';

import {
  TDiscountTableData,
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
  TServiceTableData,
} from 'modules/accommodations/features/reservations/models';

// on modal open, transform from step 2 to step 3 incoming data to API payload - (SidebarModal)
// also when click on edit service or discount populate form
export const useTransitionInStepsTransformedTableData = (
  servicesTableData: TServiceTableData[],
  discountTableData: TDiscountTableData[],
  from: string,
  to: string,
  numberOfGuestsSum: number,
  dependencyTrigger?: any,
  reservationLanguageId?: number | null,
  adultsNumber?: number,
  babiesNumber?: number,
  childrenNumber?: number,
  teensNumber?: number,
) => {
  const transitionInStepsTransformedTableData = useMemo(() => {
    const services: TServicesTableDataCalculation[] = [...servicesTableData].map(
      (item: TServiceTableData) => {
        return {
          serviceId: item.rootId,
          unitOfMeasureId: item.unitOfMeasureRootId! | item.unitOfMeasureId,
          dateFrom: item.objectDefined ? item.dateFrom : from,
          dateTo: item.objectDefined ? item.dateTo : to,
          sellingPricePerUnitOfMeasure: item.sellingPricePerUnitOfMeasure,
          purchasePricePerUnitOfMeasure: item.purchasePricePerUnitOfMeasure,
          amount: item.amount,
          numberOfGuests: numberOfGuestsSum,
          totalSellingAmountPerUnitOfMeasure: item.amount * item.sellingPricePerUnitOfMeasure,
          reservationLanguageId: reservationLanguageId,
          adults: adultsNumber,
          babies: babiesNumber,
          children: childrenNumber,
          teens: teensNumber,
        };
      },
    );

    const discounts: TDiscountTableDataCalculation[] = [...discountTableData].map(
      (item: TDiscountTableData) => {
        return {
          serviceId: item.rootId,
          reservationDiscountType: item.reservationDiscountType,
          dateFrom: item.objectDefined ? item.dateFrom : from,
          dateTo: item.objectDefined ? item.dateTo : to,
          numberOfGuests: numberOfGuestsSum,
          amountPerDiscountType: item.amountPerDiscountType,
          applyDiscountPriceTo: item.applyDiscountPriceTo,
        };
      },
    );

    return { services, discounts };
  }, [dependencyTrigger]);

  return {
    transformedServicesDataForAPI: transitionInStepsTransformedTableData.services,
    transformedDiscountsDataForAPI: transitionInStepsTransformedTableData.discounts,
  };
};
